import Cheque from '../../../../assets/payment/cheque.webp';
import Euro1 from '../../../../assets/payment/pieceEuro1.webp';
import Euro2 from '../../../../assets/payment/pieceEuro2.webp';
import Billet10 from '../../../../assets/payment/billet10.webp';
import Billet20 from '../../../../assets/payment/billet20.webp';
import CB from '../../../../assets/payment/cb.webp';
import Mandat from '../../../../assets/payment/mandat.webp';
import Mastercard from '../../../../assets/payment/mastercard.webp';
import Visa from '../../../../assets/payment/visa.webp';

export default {
  Cheque,
  Euro1,
  Euro2,
  Billet10,
  Billet20,
  CB,
  Mandat,
  Mastercard,
  Visa
};
